export default __webpack_public_path__ + "static/media/circleInfo.8e96ff9b.svg";